import React from 'react'

const RequiredFieldMark = () => {
    return <span className="required-field-mark">&#42;</span>
}

export default RequiredFieldMark
